import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "onlyIcon", "iconColor", "view", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { forwardRefWithTag } from '@carnica/utils';
import { Button as CarnicaButton } from '@carnica/ui-kit';
import { cnBem } from "../../lib";
import styles from "./styles.pcss";
var cnButton = cnBem('button', styles);
var iconColorMap = {
  tertiary: '--color-icon-primary-invert',
  primary: '--color-constant-01',
  'secondary-invert': '--color-icon-primary',
  secondary: '--color-icon-primary',
  'tertiary-invert': '--color-icon-primary-invert'
};
export var Button = forwardRefWithTag(function (props, ref) {
  var className = props.className,
    onlyIcon = props.onlyIcon,
    iconColor = props.iconColor,
    _props$view = props.view,
    view = _props$view === void 0 ? 'primary' : _props$view,
    children = props.children,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(CarnicaButton, _extends({}, otherProps, otherProps.tagName === 'button' || !otherProps.tagName ? {
    type: 'button'
  } : {}, {
    className: cnButton({
      onlyIcon: onlyIcon,
      view: view
    }, className),
    onlyIcon: onlyIcon,
    ref: ref,
    style: _objectSpread(_objectSpread({}, otherProps.style), iconColor ? _defineProperty({}, iconColorMap[view], "var(--color-icon-".concat(iconColor, ")")) : {}),
    view: view === 'tertiary-invert' ? 'tertiary' : view
  }), children);
});